import Receiver from "@/domain/receiver/Receiver";
import ComplexPayment from "@/domain/order/ComplexPayment";

class PostOrderRequest {
  constructor(public readonly productId: string,
              public readonly price: number,
              public readonly orderType: string,
              public readonly paymentMethod: string,
              public readonly receiveMessage: string,
              public readonly receivers: Array<Receiver>,
              public readonly cancelMobileUrl: string,
              public readonly complexPayment?: ComplexPayment
              ) {
  }
}

export default PostOrderRequest;